import { Link } from "wouter";
import { Panel } from "../components/ui.tsx";
import { usePageTitle } from "../lib/nav.tsx";

export function NotFoundPage() {
  usePageTitle("Página não encontrada");
  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <Panel>
        <h1 className="text-xl font-bold">Página não encontrada</h1>
        <p className="mt-2 text-sm text-muted">O endereço pode estar incorreto ou o conteúdo não está disponível para a sua conta.</p>
        <p className="mt-4">
          <Link href="/planos" className="text-sm font-semibold text-primary">Voltar para minhas oficinas</Link>
        </p>
      </Panel>
    </div>
  );
}
